export enum DashboardDatePreset {
  Today = 'TODAY',
  Yesterday = 'YESTERDAY',
  ThisWeek = 'THIS_WEEK',
  Last7Days = 'LAST_7_DAYS',
  ThisMonth = 'THIS_MONTH',
  Last30Days = 'LAST_30_DAYS',
  LastMonth = 'LAST_MONTH',
  Last3Months = 'LAST_3_MONTHS',
}

export enum DashboardWidgetWidth {
  Sixth = 'SIXTH',
  Quarter = 'QUARTER',
  Third = 'THIRD',
  Half = 'HALF',
  Full = 'FULL',
}

export interface DashboardDateRange {
  dateFrom: string;
  dateTo: string;
  preset?: DashboardDatePreset | undefined;
}
